/* eslint-disable @typescript-eslint/unbound-method */
import { FC } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { NavigateList } from 'routes/routesList';

export const App: FC = () => {
	return (
		<BrowserRouter>
			<NavigateList />
		</BrowserRouter>
	);
};
